import validate from "/Users/cdm/code/turbo/playaresorts/node_modules/nuxt/dist/pages/runtime/validate.js";
import preview_45layout_45global from "/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/voix-layer/middleware/preview-layout.global.js";
import studio_45global from "/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/voix-layer/middleware/studio.global.js";
import unsaved_45draft_45alert_45global from "/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/voix-layer/middleware/unsavedDraftAlert.global.js";
import jewel_45resorts_45redirect_45global from "/Users/cdm/code/turbo/playaresorts/apps/voix/middleware/jewel-resorts-redirect.global.ts";
import manifest_45route_45rule from "/Users/cdm/code/turbo/playaresorts/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  preview_45layout_45global,
  studio_45global,
  unsaved_45draft_45alert_45global,
  jewel_45resorts_45redirect_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}